import { QueryList } from '@angular/core';

import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';

/**
 * Get stream of first available element form QueryList
 *
 * @param queryList
 */
export function queryListFirst<T>(queryList: QueryList<T>): Observable<T> {
  return queryList.changes.pipe(
    startWith(queryList),
    map(list => list.first),
    filter(element => Boolean(element)),
    distinctUntilChanged(),
  );
}
